import { MdKeyboardBackspace } from "react-icons/md";
import {useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AllOrders from "./allOrders";
import CancledOrders from "./cancledOrders";
import ReturnOrders from "./returnOrders";
export default function SectionOne()
{
    const navigate=useNavigate();
    const [statusFilter, setStatusFilter] = useState("");
    const [activeTab, setActiveTab] = useState(1);
    const steps = [
      { id: 1, label: "All Orders" },
      { id: 2, label: "Cancelled Orders" },
      { id: 3, label: "Returned Orders" },
    ];
    const location = useLocation();  

    useEffect(() => {
      if (location.state?.activeStep) {
        const matchedStep = steps.find(step => step.label === location.state.activeStep);
        if (matchedStep) {
        setActiveTab(matchedStep.id);
      }
      }
    }, [location.state]);

    return(
<section className="py-5 md:py-8 px-4 md:px-8 xl:px-10 min-h-screen">
    <div className="flex flex-row items-center mb-5">
        <div className="flex flex-row space-x-2 items-center " onClick={()=>navigate(-1)}>
            <MdKeyboardBackspace className="text-sm md:text-base xl:text-lg" />
            <p className="text-sm md:text-base xl:text-lg font-medium ">My Orders</p>
        </div>        
    </div>

    <div className="flex flex-col md:flex-row justify-between gap-4 md:items-center mb-5">
        <div className="py-2">
        <div className="flex flex-col md:flex-row justify-between gap-4">
          {steps.map((step) => (
          <button
            key={step.id}
            onClick={() => setActiveTab(step.id)}
            className={`px-4 py-2 rounded border border-gray-600 font-semibold w-48 ${
              activeTab === step.id
                ? "bg-[#A63F40] text-white"
                : "bg-white text-gray-700"
            }`}
          >
            {step.label}
          </button>
        ))}
        </div>
        </div>
        
        <div className="flex justify-end ">
        {activeTab === "All Orders" && (
        <div className=" text-sm md:text-base xl:text-lg flex flex-row space-x-1 md:space-x-3 items-center flex-wrap gap-2">
            <p className="font-semibold">Filter by :</p>
            <select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
              }}
               className="border border-gray-500 p-1 text-xs md:text-sm rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="All">All Status</option>
              <option value="newRequest">New request</option>
              <option value="processing">Processing</option>
              <option value="shipped">Shipped</option>
              <option value="outForDelivery">Out for delivery</option>
              <option value="delivered">Delivred</option>
            </select>
        </div>
        )}
        </div>
    </div>
   

    <div className="">
        {activeTab === 1 && (
          <AllOrders  statusFilter={statusFilter}/>
        )}
        {activeTab === 2 && (
          <CancledOrders />
        )}
        {activeTab === 3 && (
          <ReturnOrders />
        )}
    </div>
        
    
</section>
    );
}